import React from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb, Form, Input, Button, Switch, DatePicker, Upload, Space, Select, Row, Col, Tag,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons'; 

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout'; 

import useUsersEditCreate from './useUsersEditCreate';
import styles from './UsersEditCreate.module.less';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Text from 'antd/lib/typography/Text'; 

import { ReactComponent as companyIcon } from '@assets/svg/company.svg';
import { ReactComponent as energyIcon } from '@assets/svg/energy.svg';  

import Icon from '@ant-design/icons/lib/components/Icon';

import ViewCreatedUser from './ViewCreatedUser';

const iconProps = {
  className: 'anticon',
  style: { fontSize: 10, minWidth: 'auto', color:'#828282' },
};

const progressBarUpload = {
  strokeColor: {
    '0%': '#108ee9',
    '100%': '#87d068',
  },
  strokeWidth: 3,
  format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
};

const { Dragger } = Upload;

function UsersEditCreate() {

  const { t } = useTranslation();
  const {
    onFinishFailed, onFinish,
    formOnValuesChange, 
    fileRequest,
    changeFile,
    dataForm,
    idToEdit,
    cancelCreateEditUser,
    businessData,
    devicesData,
    clientsData,
    isModalVisible,
    setIsModalVisible,
    modalData,
    currentUserRol,
    clearRol,
    onDataVisitor,
    typeVisitor,
    form,
    loadingForm
  } = useUsersEditCreate();
   
  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Breadcrumb className={styles.date_wrapper}>
          <Breadcrumb.Item className={styles.breadcrumb}>
            <Link to="/usuarios">{t('views.users.breadcrumb.users')}</Link>
          </Breadcrumb.Item>
          {(idToEdit)
            ? (
              <>
                <Breadcrumb.Item className={styles.breadcrumb}>{t('forms.users.update_title')}</Breadcrumb.Item>
                <Breadcrumb.Item className={styles.breadcrumb}>{idToEdit}</Breadcrumb.Item>
              </>
            )
            : <Breadcrumb.Item className={styles.breadcrumb}>{t('forms.users.create_title')}</Breadcrumb.Item>}
        </Breadcrumb>

         {/* Primera fila */}
 
        <Form
          form={form}
          name="CreateUser"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 22 }}
          layout="vertical"
          className={styles.totalForm}
          initialValues={{
            ...dataForm, remenber: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={formOnValuesChange}
          autoComplete="off"
        >

          <Row gutter={16}> 
              <Col span={24}>
                <div> 
                    <h2 style={{marginBottom:0}}>{(idToEdit)?t('forms.users.update_title'):t('forms.users.create_title')}</h2> 
                </div>
              </Col>
          </Row> 

          <Row gutter={16} style={{marginTop:15}}> 
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  className={styles.label}
                  label={t('forms.users.labels.name')}
                  name="first_name"
                  rules={[
                    { required: true, message: t('forms.users.rules.name') },
                  ]}
                >
                  <Input className={styles.input} placeholder={t('forms.users.placeholders.name')} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                    className={styles.label}
                    label={t('forms.users.labels.last_name')}
                    name="last_name"
                    rules={[
                      { required: true, message: t('forms.users.rules.last_name') },
                    ]}
                  >
                  <Input className={styles.input} placeholder={t('forms.users.placeholders.last_name')} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  className={styles.label}
                  label={t('forms.users.labels.email')}
                  name="email"
                  rules={[
                    { required: true, message: t('forms.users.rules.email') },
                    { type: 'email', message: t('forms.users.rules.type_email') },
                  ]} 
                >
                  <Input className={styles.input}  disabled={idToEdit} placeholder={t('forms.users.placeholders.email')} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  className={styles.label}
                  label={t('forms.users.labels.birth_date')}
                  name="birthdate"
                  rules={[
                    { required: true, message: t('forms.users.rules.birth_date') },
                  ]} 
                  getValueProps={(date) => ({ value: date})}
                >
                  <DatePicker
                      style={{width:'100%'}}
                      className={styles.input} 
                      placeholder={t('forms.users.placeholders.birth_date')} 
                  />
                </Form.Item>
              </Col>
                
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                  className={styles.label}
                  label={t('forms.users.labels.phone')}
                  name="phone"
                  rules={[
                    {  required: true, message: t('forms.users.rules.phone') },
                    () => ({
                      validator(_, val) {

                        if (val.length > 10) {

                          return Promise.reject(
                            t('views.dynamic_alarms_create_edit.feedbacks.max_number'),
                          );

                        }
                        if (val.length < 7) {

                          return Promise.reject(
                            t('views.dynamic_alarms_create_edit.feedbacks.min_number'),
                          );

                        }
                        return Promise.resolve();

                      },
                    }),
                  ]}
                >
                  <Input type="number" className={styles.input} placeholder={t('forms.users.placeholders.phone')} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  className={styles.label}
                  label={t('forms.users.labels.avatar_image')}
                  name="avatar_image"
                > 
                  <Dragger
                    rules={[{ message: t('forms.users.rules.avatar_image') }]}
                    beforeUpload={() => true}
                    customRequest={fileRequest}
                    onChange={changeFile}
                    multiple={false}
                    maxCount={1}
                    progress={progressBarUpload}
                    height={35}       
                  >
                    <div style={{marginTop:-10,textAlign:'left', marginLeft:10}}>
                      <FontAwesomeIcon icon={faUpload} {...iconProps} />
                      <Text style={{color:'#828282'}}>{' '}{t('forms.users.placeholders.avatar_image')}</Text>
                    </div>  
                    
                  </Dragger>
                </Form.Item> 
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                <Form.Item
                  className={styles.label}
                  label={t('forms.users.labels.rol')}
                  name="role"
                  rules={[
                    { required: true, message: t('forms.users.rules.rol') },
                  ]}
                >
                  <Select 
                    style={{ width: '100%' }}
                    placeholder={t('forms.users.placeholders.rol')}
                    onChange={(value) => clearRol(value)} 
                    options={[
                          currentUserRol === 'Superadmin' && { value: 'Superadmin', label: t('forms.users.labels.roles.superadmin') },
                          { value: 'Admin', label: t('forms.users.labels.roles.admin') },
                          { value: 'Analyst', label: t('forms.users.labels.roles.analyst') },
                          { value: 'Visitor', label: t('forms.users.labels.roles.visitor') },
                      ].filter(Boolean)}
                    disabled={(idToEdit && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin') || (dataForm?.role === 'Visitor' && idToEdit)}
                  /> 
                </Form.Item>
              </Col>

              {
                dataForm?.role !== 'Superadmin' && 
                dataForm?.role !== 'Visitor' && 
                dataForm?.role !== '' &&
                <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                  <Form.Item
                    className={styles.label}
                    label={t('forms.users.labels.business_line')}
                    name="business_id"//business_type
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) => (option?.label ?? '').includes(input)}
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                      } 
                      style={{ width: '100%' }}
                      placeholder={t('forms.users.placeholders.business_line')}
                      mode="multiple"
                      options={businessData}
                      disabled={idToEdit && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin'}
                    /> 
                  </Form.Item>
                </Col>
              } 

              { 
                dataForm?.role === 'Visitor' && 
                dataForm?.role !== '' &&
                <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                  <Form.Item
                    className={styles.label}
                    label={t('forms.users.labels.business_line')}
                    name="business_id_visitor"//business_type
                  >
                    <Select 
                      onChange={(value) => onDataVisitor(value)}
                      style={{ width: '100%' }}
                      placeholder={t('forms.users.placeholders.business_line')} 
                      options={businessData}
                      disabled={idToEdit && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin'}
                    /> 
                  </Form.Item>
                </Col>
              } 

              {
                typeVisitor === 'Retail' && typeVisitor !== '' &&
                <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                  <Form.Item
                    className={styles.label}
                    label={t('forms.users.labels.devices')}
                    name="devices_id"
                  >
                    <Select 
                    style={{ width: '100%' }}
                    placeholder={t('forms.users.placeholders.devices')} 
                    options={devicesData}
                    disabled={idToEdit && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin'}
                  /> 
                  </Form.Item>
                </Col>
              }
              {
                typeVisitor === 'Comunidades' && typeVisitor !== '' &&
                <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                  <Form.Item
                    className={styles.label}
                    label={t('forms.users.labels.clients')}
                    name="clients_id"
                  >
                    <Select 
                    style={{ width: '100%' }}
                    placeholder={t('forms.users.placeholders.clients')} 
                    options={clientsData}
                    disabled={idToEdit && currentUserRol !== 'Superadmin' && currentUserRol !== 'Admin'}
                  /> 
                  </Form.Item>
                </Col>
              }

          </Row> 
          {
            dataForm?.role !== 'Visitor' &&
            <Row gutter={16} style={{marginTop:10}}> 
              {
                dataForm?.business_id?.length>0 && (
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <p>
                      <strong>
                        <span className={styles.spacingText}>•</span>
                        {' '}{t('tables.users.columns.access')}
                      </strong>
                    </p>
                  </Col> 
                )
              } 
                <Col>
                  {
                    dataForm?.business_id?.map((businessLine, index) => { 
                      const businessLineObject = businessData.find(item => item.value === businessLine);  
                      if (businessLineObject) {
                        return (
                          <Tag
                            icon={<Icon component={businessLineObject.type === 'Comunidades' ? companyIcon : energyIcon} style={{ fontSize: 16 }} />}
                            color="default"
                            className={styles.tagMargin}
                            key={index}
                          >
                            <span className={styles.textTag}>{businessLineObject.label}</span><br /> 

                            {businessLineObject.type === 'Comunidades' ? 
                            <span className={styles.textTag2}>• {t('forms.users.labels.clients')}: {businessLineObject.clients}</span> : 
                            <span className={styles.textTag2}>• {t('forms.users.labels.devices')}: {businessLineObject.devices}</span>}
                          </Tag>
                        );
                      }

                      return null;
                    })
                  }
                </Col>
            </Row>
          }
          
          <Row style={{marginTop:25, justifyContent:'end'}}>
              
              <Button key="back" className='m_l' onClick={() => cancelCreateEditUser()}>
                <span className={styles.textTag2}>{t('forms.users.buttons.cancel')}</span>
              </Button>

              <Button key="button"  className='m_l' type="primary" loading={loadingForm} htmlType="submit" icon={(!idToEdit) ?<PlusOutlined />:null} >
                 {(!idToEdit) ? t('forms.users.buttons.create') : t('forms.users.buttons.update') }
              </Button> 
              
          </Row>
        </Form>
      </div>

      <ViewCreatedUser
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible} 
          modalData={modalData}
      />

    </MainLayout>
  );

}

export default withAuth(UsersEditCreate);
